module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-9-17f58c13099ddb8a70d9a4b35ea63447.svg";